
import React, {Component} from 'react';
import {Modal,Button,FormGroup,ControlLabel} from 'react-bootstrap'

import FontAwesome from 'react-fontawesome'
// import SWTCustomerPage from './SWTCustomerPage'
import SWTCarCatModal from './SWTCarCatModal'
import Select from 'react-select'
import WorkdocStore from '../../stores/WorkdocStore'


class SWTCarEditModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {carTypeSel:null,carBrandSel:null,showCat:false,modelSel:null,brand:[],model:[],series:[]}

    //this.openPopup() 
    
  }

  componentDidMount(){
    this.loadBrandOptions();
  }

  getCarTypeOption(){
    return [{value:'SEDAN',label:'รถเก๋ง',imgUrl:"https://swt.bigfix.co/sriracha/img/SEDAN-32x32.png"},
            {value:'PICKUP',label:'รถกระบะ',imgUrl:"https://swt.bigfix.co/sriracha/img/PICKUP-32x32.png"},
            {value:'VAN',label:'รถตู้',imgUrl:"https://swt.bigfix.co/sriracha/img/VAN-32x32.png"},
            {value:'TRUCK',label:'รถบรรทุก',imgUrl:"https://swt.bigfix.co/sriracha/img/TRUCK-32x32.png"}]
  }

  getBrandOptions(input, callback) {
    WorkdocStore.loadCarCategory(0,function(result){
      let options = result.data.map((item,index)=>{
          return { value: item.cat_id, label: item.name }
        })
      callback(null, {        
        options: options,
        complete: true
      });
    })
    
  }

  loadBrandOptions(initCatId=''){
    let {carBrandSel} = this.state
    let that = this
    WorkdocStore.loadCarCategory(0,function(result){
      let loadModel = false
      let options = result.data.map((item,index)=>{
        
        const option = { value: item.cat_id, label: item.name }
          if(initCatId*1===item.cat_id*1){
            carBrandSel = option
            //Load Model
            loadModel = true
          }
          return option
        })
      that.setState({brand:options,carBrandSel:carBrandSel})
      if(loadModel){
        WorkdocStore.loadCarCategory(initCatId,function(result){
          
          that.setState({model:result.data})
        })
      }
    })    
  }

  openPopup(catId){
    //console.log("ref",this.refs.swtCustPop)
    //this.refs.swtCustPage.loadPage()    
    this.loadBrandOptions(catId);    
  }

  onSelectCustomerItem(item){
    window.onSelectCustomerItem(item)
    this.props.onHide()
  }

  onCarTypeChange(value){
    this.setState({carTypeSel:value})
  }

  onCarBrandChange(value){
    this.setState({carBrandSel:value})
    let that = this
    if(value!==null && typeof value!=='undefined'){
      WorkdocStore.loadCarCategory(value.value,function(result){
        
        that.setState({model:result.data})
      })
    }else{
      this.setState({model:[],series:[],modelSel:null})
    }
  }

  onSerieRowClick(item){
    console.log('item',item)
  }

  onModelRowClick(item){
    console.log('item',item)
    let that = this
    WorkdocStore.loadCarCategory(item.cat_id,function(result){
        that.setState({series:result.data})
      })

    this.setState({modelSel:item})
  }

  onBrandClick(){
    this.setState({showCat:true,catTitle:'ยี่ห้อรถ',catId:0})
  }

  onModelClick(){
    let {carBrandSel} = this.state
    if(typeof carBrandSel!=='undefined' && carBrandSel!==null){
      let catTitle = (<span><img src={'https://swt.bigfix.co/sriracha/img/car_brand/'+carBrandSel.label+'-32x32.png'}/>
        {carBrandSel.label}
      </span>
      )
      this.setState({showCat:true,catTitle:catTitle,catId:carBrandSel.value})
    }else{
      alert("กรุณาเลือกยี่ห้อรถ");
    }
    
  }


  onSerieClick(){
    let {carBrandSel,modelSel} = this.state
    if(typeof carBrandSel!=='undefined' && carBrandSel!==null && modelSel!==null){
      let catTitle = (<span><img src={'https://swt.bigfix.co/sriracha/img/car_brand/'+carBrandSel.label+'-32x32.png'}/>
        {carBrandSel.label+' - '+modelSel.name +' * บอกช่วงปีที่ผลิต ตัวอย่าง (ปี 2014-2016)'}
      </span>
      )
      this.setState({showCat:true,catTitle:catTitle,catId:modelSel.cat_id})
    }else if(carBrandSel==null){
      alert("กรุณาเลือกยี่ห้อรถ");
    }else{
      alert("กรุณาเลือกรุ่นรถ");
    }
  }

  onModelDelClick(item,index){
    // let {model} = this.state
    // let that = this
    // WorkdocStore.delCarCategory(item.cat_id,function(result){        
    //     model.splice(index,1)
    //     that.setState({model:model})
    //   })

    console.log('modelDel')
  }

  onSerieDelClick(item,index){
    let {series} = this.state
    let that = this
    WorkdocStore.delCarCategory(item.cat_id,function(result){        
        series.splice(index,1)
        that.setState({series:series})
      })
  }

  onAfterSubmit(){
    let {catId,carBrandSel,modelSel} = this.state
    let that = this
    if(catId===0){
      this.setState({brand:[],model:[],series:[],modelSel:null})
      this.loadBrandOptions()
    }else if(carBrandSel.value===catId){
      this.setState({model:[]})
      WorkdocStore.loadCarCategory(catId,function(result){        
        that.setState({model:result.data})
        if(that.props.onChange!==undefined){
          that.props.onChange(catId)
        }
      })
    }else if(modelSel.cat_id===catId){
      this.setState({series:[]})
      WorkdocStore.loadCarCategory(catId,function(result){        
        that.setState({series:result.data})
        if(that.props.onChange!==undefined){
          that.props.onChange(catId)
        }        
      })
    }
  }

  renderOption(option) {
		return (
      <span><img src={option.imgUrl}/> {option.label}</span>			
		);
  }
  
  renderBrandOption(option){
    return (
      <span><img src={'https://swt.bigfix.co/sriracha/img/car_brand/'+option.label+'-32x32.png'}/> {option.label}</span>			
    )
  }

  renderSearch(){
    let {carTypeSel,carBrandSel,brand} = this.state
    return (
      <div className='row'>
        <div className='col-md-3'>
          
        </div>
        <div className='col-md-6'>
          <FormGroup >
            <ControlLabel>ยี่ห้อรถ</ControlLabel>
            <div>
            <Select   
            className='select-plus'         
            placeholder={'เลือกยี่ห้อรถ'}
            value={carBrandSel}
            onChange={this.onCarBrandChange.bind(this)}
            options={brand}
            optionRenderer={this.renderBrandOption.bind(this)}
            />  
            <Button   onClick={this.onBrandClick.bind(this)}><FontAwesome name='plus'/></Button>       
            </div>
          </FormGroup>
        </div>
        <div className='col-md-3'>
        </div>
      </div>
    )
  }

  renderModelRow(){
    let {model,modelSel} = this.state
    console.log('model',model)
    if(model.length===0){
      return (
        <tr><td>ไม่พบรุ่นรถ</td></tr>
      )
    }
    return model.map((item,index)=>(
                <tr key={index} 
                  className={(modelSel!==null && modelSel.cat_id===item.cat_id)?'selected':''}
                  onClick={this.onModelRowClick.bind(this,item)}>
                  <td>{item.name}
                  </td>
                </tr>
              ))
  }

  renderSeriesRow(){
    let {series} = this.state

    if(series.length===0){
      return (
        <tr><td>ไม่พบรุ่น</td></tr>
      )
    }

    return series.map((item,index)=>(
                <tr key={index} onClick={this.onSerieRowClick.bind(this,item)}>
                  <td>
                    {item.name}
                    <Button  bsSize="xsmall" className='pull-right' bsStyle={'danger'} 
                    onClick={this.onSerieDelClick.bind(this,item,index)}><FontAwesome name='minus'/></Button>       
                  </td>
                </tr>
              ))
  }

  renderSearchResult(){
    let {modelSel,model,series} = this.state
    return (
      <div className='row'>
        <div className='col-md-6'>
          
          <table className='table table-responsive table-hover table-bordered-solid'>
            <thead>
              <tr>
                <th>รุ่นรถ<Button bsSize="xsmall" className='pull-right'  onClick={this.onModelClick.bind(this)}><FontAwesome name='plus'/></Button></th>
              </tr>
            </thead>
            <tbody>
              {this.renderModelRow()}              
            </tbody>
          </table>
        </div>             
        <div className='col-md-6'>
           <table className='table table-responsive table-hover table-bordered-solid'>
            <thead>
              <tr>
                <th>โฉมปี <Button bsSize="xsmall" className='pull-right'  onClick={this.onSerieClick.bind(this)}><FontAwesome name='plus'/></Button></th>
              </tr>
            </thead>
            <tbody>
              {this.renderSeriesRow()} 
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  renderModal(){
    let {show} = this.props
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{'ค้นหาแบรนด์รถ'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderSearch()}
          {this.renderSearchResult()}
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    )
  }

  renderTable() {
    return(
      <div>
        {this.renderSearch()}
        {this.renderSearchResult()}
      </div>
    )
  }

  render(){
    let {showCat,catTitle,catId} = this.state
    let {mode} = this.props
    return(
      <div>
        {mode==='modal'?
        this.renderModal()
        :this.renderTable()}
        <SWTCarCatModal 
          show={showCat} 
          title={catTitle} 
          catId={catId}
          onAfterSubmit={this.onAfterSubmit.bind(this)}
          onHide={()=>{this.setState({showCat:false})}}
        />
      </div>  
    )
  }
}

SWTCarEditModal.defaultProps = {
  mode: 'modal'
}

export default SWTCarEditModal;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTCarEditModal.js